<template>
    <div class="history-getfriend m-auto" data-cy="container_history_getfriend_main">
        <div v-if="isPeriod">
            <GetFriendShare />
            <GetFriendList class="mt-5" />
            <GetFriendDashboard :dashboard="arrDashboard" />
        </div>
        <div v-else data-cy="container_history_getfriend_coming_soon">
            <div class="content-nodata flex flex-col my-auto justify-center items-center">
            <div class="text-16 text-a-blue-2140a6 pb-4" data-cy="text_history_getfriend_coming_soon">{{ lbl.coming_soon }}</div>
            <div>
                <img src="@/assets/icon/ic-comingsoon.png" data-cy="icon_history_getfriend_coming_soon" />
            </div>
        </div>
        </div>
    </div>
</template>
<script>
//helper
import Locale from "@/helper/locale/Locale.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
//component
import GetFriendShare from './GetFriendShare.vue';
import GetFriendList from './GetFriendList.vue';
import GetFriendDashboard from './GetFriendDashboard.vue';
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

export default {
    name: 'HistoryGetFriend',
    mixins: [LocaleMixin],
    components: {
        GetFriendShare,
        GetFriendList,
        GetFriendDashboard,
    },
    data: function() {
        return {
           dashboardConfig: 'bblprivilege_friend_condition',
           arrDashboard: [],
           isPeriod: true,
        };
    },
    created: async function() {
        let res = await this.getDashboard();

        if(res) {
            this.arrDashboard = res;
            if(this.arrDashboard.length > 0){
                this.checkDate();
            }else{
                this.isPeriod = false;
            }
            
        }
        console.log('this.arrDashboard', this.arrDashboard);  
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            return new Promise((resolve) => {
                BzbsDashboard.apiGetSubDashboard(params, this.dashboardConfig).subscribe((data) => {
                    resolve(data);
                }, (err) => {
                    resolve(null);
                    console.log(err);
                });
            }); 
        },
        checkDate: function() {
            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.arrDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.arrDashboard[0].endDate);
            console.log('currentDate', currentDate);
            console.log('start', start);
            console.log('end', end);
            if (currentDate >= start  && currentDate <= end) {
                this.isPeriod = true;
            }else{
                this.isPeriod = false;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .history-getfriend {
        max-width: 500px;
    }
    .content-nodata{
        min-height: calc(100vh - 300px);
    }
</style>
